import PayoneerPaymentFields from "../PayoneerPaymentFields";
import { getPaymentBox, selectedPaymentGatewayId } from "./woocommerce";


let fieldInstances = {};

export const createPaymentFields = ( gatewayId, sdk ) => {
	const {
		paymentFieldsContainerId,
		paymentFieldsComponentAttribute,
		onErrorRefreshFragmentFlag,
	} = window.PayoneerData;

	fieldInstances[ gatewayId ] = new PayoneerPaymentFields( {
		sdk,
		paymentFieldsContainerId,
		paymentFieldsComponentAttribute,
		onErrorRefreshFragmentFlag,
	} );

	const element = getPaymentBox( gatewayId );
	if ( element ) {
		fieldInstances[ gatewayId ].setElement( element );
	}

	return fieldInstances[ gatewayId ];
};


export const getPaymentFields = ( gatewayId ) => fieldInstances[ gatewayId ];
export const getCurrentPaymentFields = () => getPaymentFields( selectedPaymentGatewayId() );
